import styled from 'styled-components';

import { List, Button } from '@gympass/yoga';

import * as EndUserStyle from '../EndUser/styles';

export const CrumbContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;

  + hr {
    margin: 0px;
  }
`;

export const Divisor = styled.hr`
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  margin: ${({ theme }) => theme.yoga.spacing.zero}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const LogbookList = styled(List)`
  li:nth-child(2n) {
    background-color: ${({ theme }) => theme.yoga.colors.white};
  }
`;

export const LogbookFooter = styled.footer`
  display: flex;
  align-items: center;
  margin-top: 35px;
`;

export const LogbookAddButton = styled(Button)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const TabsContainer = styled(EndUserStyle.TabsContainer)``;

export const UserInfoContainer = styled(EndUserStyle.UserInfoContainer)``;
